export default __webpack_public_path__ + "static/youngChild-d50c986d4259620ffbb12b2da6933795.svg";